import FocusTrap from 'focus-trap-react';
import Button from '../button/button.component';
import CloseButton from '../close-button/close-button.component';
import { ModalDialogContainer } from './modal-dialog.styles';
import { FlexContainer } from '../flex-container/flex-container.styles';
import { testIds } from '../../../test-ids';

interface Props {
  isLoading?: boolean;
  isOpen: boolean;
  isDanger?: boolean;
  onClose?: () => void;
  onApprove?: () => void;
  approveBtnContent?: string;
  approveBtnDisabled?: boolean;
  cancelBtnContent?: string;
  width?: string;
  height?: string;
  padding?: string;
  paddingMobile?: string;
  children: React.ReactNode;
  displayButtons?: boolean;
  hideCloseButton?: boolean;
  useApproveLogicForDialogClosing?: boolean; // May be useful when dialog was designed in a way when approve logic should be applied to cancel button
  isMobileFullScreen?: boolean;
  mobileTopOffset?: string;
  buttonsGap?: string;
  boxShadow?: string;
}

const ModalDialog = ({
  children,
  isDanger = false,
  isOpen,
  onClose = () => {},
  onApprove = () => {},
  approveBtnContent,
  approveBtnDisabled,
  cancelBtnContent,
  width = '60rem',
  height,
  padding = '3.2rem 4rem',
  paddingMobile = '3.2rem',
  displayButtons = true,
  useApproveLogicForDialogClosing = false,
  isLoading,
  hideCloseButton,
  isMobileFullScreen,
  mobileTopOffset,
  buttonsGap = '1.6rem',
  boxShadow,
}: Props) => (
  <ModalDialogContainer
    $widthModal={width}
    $heightModal={height}
    $padding={padding}
    $paddingMobile={paddingMobile}
    $isMobileFullScreen={isMobileFullScreen}
    $boxShadow={boxShadow}
    backgroundProps={
      mobileTopOffset ? { $mobileTopOffset: mobileTopOffset } : undefined
    }
    data-testid={testIds.common.modal}
    isOpen={isOpen}
    onBackgroundClick={!useApproveLogicForDialogClosing ? onClose : onApprove}
    onEscapeKeydown={!useApproveLogicForDialogClosing ? onClose : onApprove}>
    <FocusTrap
      focusTrapOptions={{
        initialFocus: false,
      }}>
      <div>
        {!hideCloseButton && (
          <CloseButton
            onClick={(e) => {
              e.stopPropagation();
              !useApproveLogicForDialogClosing ? onClose() : onApprove();
            }}
          />
        )}
        {children}
        <FlexContainer
          $gap={buttonsGap}
          $justify='flex-end'
          $mobDirection='column'>
          {displayButtons && !!cancelBtnContent && (
            <Button
              appearance='secondary'
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              fullWidth={false}
              fullWidthMobile>
              {cancelBtnContent}
            </Button>
          )}

          {displayButtons && !!approveBtnContent && (
            <Button
              isLoading={isLoading}
              disabled={approveBtnDisabled}
              appearance={isDanger ? 'danger' : 'primary'}
              onClick={(e) => {
                e.stopPropagation();
                onApprove();
              }}
              fullWidth={false}
              fullWidthMobile>
              {approveBtnContent}
            </Button>
          )}
        </FlexContainer>
      </div>
    </FocusTrap>
  </ModalDialogContainer>
);

export default ModalDialog;
